export function Marquee({ items, dark = false }) {
  const row = [...items, ...items];
  const starColors = ["text-c-blue", "text-c-teal", "text-c-amber", "text-c-violet", "text-c-rose"];
  return (
    <div className="overflow-hidden py-6 select-none" data-testid="editorial-marquee">
      <div className="marquee-track">
        {row.map((it, i) => (
          <span key={i} className="inline-flex items-center">
            <span
              className={`font-display text-6xl md:text-8xl px-8 ${
                dark ? "text-stroke-ink" : "text-stroke"
              }`}
            >
              {it}
            </span>
            <span className={`${starColors[i % starColors.length]} text-4xl md:text-6xl`}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
